import { jsx as _jsx } from "react/jsx-runtime";
import { CatModal } from "blocks-nextjs/blocks-react/components/Modal/Modal";
import EnergyLossChart from "../Charts/EnergyLossChart";
const EnergyLossChartModal = ({ onDiscardClick, showEnergyLossChartModal }) => {
    return (_jsx(CatModal, { className: "min-h-[60vh]", "data-test": "energy-loss-chart-modal", disableBackdropClick: true, heading: "SoC Over Time (Idle)", headingVariant: "title", isActive: showEnergyLossChartModal, onBlModalClose: () => {
            onDiscardClick();
        }, size: "lg", verticalMaxHeight: "large", width: "822px", children: _jsx("div", { className: "min-h-[20vh]", "data-test": "energy-loss-chart-modal-content", children: showEnergyLossChartModal && _jsx(EnergyLossChart, {}) }) }));
};
export default EnergyLossChartModal;
